import { render } from "./JenaTableTh.vue?vue&type=template&id=1c04b1f0"
import script from "./JenaTableTh.vue?vue&type=script&lang=js"
export * from "./JenaTableTh.vue?vue&type=script&lang=js"

import exportComponent from "/home/afs/ASF/Release/jena/target/checkout/jena-fuseki2/jena-fuseki-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__